import * as z from "zod";

export const EquipmentStatusEnum = z.enum([
  "active",
  "maintenance",
  "out-of-service",
  "retired",
]);

export const WarrantyStatusEnum = z.enum([
  "active",
  "expired",
  "pending",
  "void",
]);

export const EquipmentSchema = z.object({
  id: z.string().uuid(),
  name: z
    .string()
    .min(1, "Name is required")
    .max(255, "Name must be less than 255 characters"),
  serial_number: z
    .string()
    .max(100, "Serial number must be less than 100 characters")
    .optional(),
  manufacturer: z
    .string()
    .max(100, "Manufacturer must be less than 100 characters")
    .optional(),
  year: z
    .number()
    .int("Year must be a whole number")
    .min(1900, "Year must be after 1900")
    .max(new Date().getFullYear() + 1, "Year cannot be in the future")
    .optional(),
  purchase_date: z.date().optional(),
  purchase_price: z
    .number()
    .multipleOf(0.01, "Price must have at most 2 decimal places")
    .min(0, "Price cannot be negative")
    .max(9999999.99, "Price cannot exceed 9,999,999.99")
    .optional(),
  location: z
    .string()
    .max(255, "Location must be less than 255 characters")
    .optional(),
  status: EquipmentStatusEnum.default("active"),
  last_inspection: z.date().optional(),
  next_inspection: z.date().optional(),
  warranty_status: WarrantyStatusEnum.default("active"),
  created: z
    .date()
    .optional()
    .default(() => new Date()),
  updated: z
    .date()
    .optional()
    .default(() => new Date()),
});

export const createEquipmentSchema = EquipmentSchema.omit({
  id: true,
  created: true,
  updated: true,
});

export const updateEquipmentSchema = EquipmentSchema.partial().omit({
  id: true,
  created: true,
  updated: true,
});
